import { CardBody, CardHeader, CardFooter, Card, Row, Col, Label } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
import ColorSelectorModal from '../common/controls/colorSelectorModal';
import SaveButton from '../common/controls/saveButton';
import Loader from '../common/loader';
import InfoEditor from './infoEditor';
import FreeTextEditor from './freeTextEditor';
const capitalizeFirstLetter = string => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};
const AnnotationDetailViewPanel = ({
  saveState: _saveState = 'disabled',
  annotation: _annotation = {},
  footer: _footer = null,
  loading: _loading = false,
  type: _type = null,
  containerMaxHeight,
  handleSave,
  onChange
}) => {
  const selectionMessage = _type ? /*#__PURE__*/React.createElement("h3", {
    className: "t-aedvp-edit-header"
  }, "Select ", _type.charAt(0) === 'i' ? 'an' : 'a', " ", _type, " annotation") : /*#__PURE__*/React.createElement("h3", {
    className: "t-aedvp-header"
  }, "Select an annotation type to edit");

  // static now, but can re-size if additional items are added to the card header
  const headerHeight = 59;
  const footerHeight = 59;
  const handleColorChange = color => onChange('colorString', color);
  let editorContents = null;
  if (_type === 'info') {
    editorContents = /*#__PURE__*/React.createElement(InfoEditor, {
      annotation: _annotation,
      onChange: onChange
    });
  } else if (_type === 'freeText') {
    editorContents = /*#__PURE__*/React.createElement(FreeTextEditor, {
      annotation: _annotation,
      onChange: onChange
    });
  }
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      minWidth: 250
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    id: "detail-card-header",
    style: {
      paddingBottom: 20,
      paddingLeft: 10,
      paddingRight: 10
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      float: 'right'
    }
  }, /*#__PURE__*/React.createElement(SaveButton, {
    onSave: handleSave,
    saveState: _saveState,
    className: "t-aedvp-save",
    size: "sm"
  }))), /*#__PURE__*/React.createElement(CardBody, {
    style: {
      maxHeight: containerMaxHeight - headerHeight - footerHeight,
      overflow: 'auto'
    },
    className: `t-aedvp-${_type}-container`
  }, /*#__PURE__*/React.createElement(Loader, {
    loaded: !_loading
  }, Object.keys(_annotation).length ? /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h3", null, capitalizeFirstLetter(_type), " Annotation"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, {
    style: {
      paddingBottom: '10px'
    }
  }, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(Label, null, "Color")), /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(ColorSelectorModal, {
    className: "t-aedvp-color-selector",
    selectedColor: _annotation.colorString,
    onChange: handleColorChange,
    indicatorShape: "rectangle"
  }))), editorContents) : selectionMessage)), _footer ? /*#__PURE__*/React.createElement(CardFooter, {
    style: {
      paddingLeft: 10,
      paddingRight: 10
    }
  }, _footer) : null);
};
AnnotationDetailViewPanel.propTypes = {
  type: PropTypes.string,
  loading: PropTypes.bool,
  annotation: PropTypes.shape({
    id: PropTypes.string,
    colorString: PropTypes.string
  }),
  containerMaxHeight: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  footer: PropTypes.node,
  saveState: PropTypes.string
};
export default AnnotationDetailViewPanel;